import styled from 'styled-components';
import { Button } from 'kenobi-ui';

const PurpleButton = styled(Button)`
  background-color: #551A8B;
`;

export default PurpleButton;
